import React, { useState } from "react";
import { useDevice } from "../../context/DeviceModalContext";
import { FILTER_LIST, DeviceFilter } from "../../constants";
import DSSwitch from "../../../system-design/DSSwitch";
import DSBox from "../../../system-design/DSBox";
import DSCard from "../../../system-design/DSCard";
import DSTypography from "../../../system-design/DSTypography";
import DSCardContent from "../../../system-design/DSCardContent";
import DSFormControlLabel from "../../../system-design/DSFormControlLabel";
import DSSectionHeading from "../../../system-design/DSSectionHeading";
import { sectionCardSx } from "../../../system-design/sectionCardSx";

const DeviceFiltersCard: React.FC = () => {
  const { device, updateConfig } = useDevice();

  const [loading, setLoading] = useState(false);
  const [filterErrors, setFilterErrors] = useState<Record<string, string>>({});

  const filterValues = Object.fromEntries(
    FILTER_LIST.map((f) => {
      const deviceValue = device?.[f.id as keyof typeof device]?.value;
      return [f.id, deviceValue === false];
    }),
  ) as Record<DeviceFilter, boolean>;

  const handleFilterChanged = async (checked: boolean, filterId: string) => {
    setLoading(true);
    setFilterErrors((prev) => ({ ...prev, [filterId]: "" }));
    try {
      await updateConfig(filterId, !checked);
    } catch (error) {
      const config = FILTER_LIST.find((f) => f.id === filterId);
      setFilterErrors((prev) => ({
        ...prev,
        [filterId]: `${config?.errorPrefix}: ${(error as Error).message || "Unknown error"}`,
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DSCard className="card-stats" sx={[sectionCardSx, { mb: 2 }]}>
      <DSSectionHeading>Filters</DSSectionHeading>
      <DSCardContent>
        <DSBox sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {FILTER_LIST.map((filter) => (
            <DSBox key={filter.id}>
              <DSFormControlLabel
                control={
                  <DSSwitch
                    checked={filterValues[filter.id]}
                    onChange={(e) =>
                      handleFilterChanged(e.target.checked, filter.id)
                    }
                    disabled={loading}
                  />
                }
                label={
                  <DSTypography variant="body1">{filter.label}</DSTypography>
                }
              />
              {filterErrors[filter.id] && (
                <DSTypography
                  variant="body2"
                  color="error"
                  sx={{ mt: 1, ml: 4 }}
                >
                  {filterErrors[filter.id]}
                </DSTypography>
              )}
            </DSBox>
          ))}
        </DSBox>
      </DSCardContent>
    </DSCard>
  );
};

export default DeviceFiltersCard;
